import React from 'react';
import { Container, Box, Typography, Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getDefaultRoute } from '../../utils/getDefaultRoute';

const ErrorPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const params = new URLSearchParams(location.search);
  const reason = params.get('reason');

  const handleNavigation = () => {
    if (user) {
      navigate(getDefaultRoute(user.role, user));
    } else {
      navigate('/login');
    }
  };

  const title = reason ? 'Service Unavailable' : 'Page Not Found';
  const code = reason ? '503' : '404';
  const message = reason
    ? reason
    : 'Oops! The page you are looking for does not exist. It might have been moved or deleted.';

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
        }}
      >
        <Typography variant="h1" component="h1" color="primary" gutterBottom>
          {code}
        </Typography>
        
        <Typography variant="h5" component="h2" gutterBottom>
          {title}
        </Typography>
        
        <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 4 }}>
          {message}
        </Typography>

        <Button 
          variant="contained" 
          size="large" 
          onClick={handleNavigation}
        >
          {user ? 'Back to Dashboard' : 'Go to Login'}
        </Button>
      </Box>
    </Container>
  );
};

export default ErrorPage;
